import config from '../config'
export default {
    created () {
      config.getData('/common')
      .then(response => {
        if (response.status_code === 200) {
          this.$store.commit('mutateCommonProperties', {
            coverageAreaList: response.coverageAreaList,
            districtList: response.districtList,
            thanaList: response.thanaList,
            areaList: response.areaList,
            // merchantAreaList: response.merchantAreaList,
            merchantStoreList: response.merchantStoreList,
            merchantWeightList: response.merchantWeightList,
            bankList: response.bankList,
            hubList: response.hubList,
            issueList: response.issueList,
          })
        }
      })
    }
}